<div class="flex-col inactivity-modal">
  <div>
    <span class="icon ui-icon-time"></span>
  </div>
  <div class="title">{{ 'INACTIVITY.TITLE' | translate }}</div>
  <div class="description">
    {{ 'INACTIVITY.DESCRIPTION' | translate: { seconds: secondsLeft } }}
  </div>
  <button mat-flat-button color="primary" (click)="close()">
    {{ 'COMMON.YES' | translate }}
  </button>
</div>
